// extracted by mini-css-extract-plugin
export var center = "styles-module--center--3de35";
export var controlContainer = "styles-module--controlContainer--49e0a";
export var controlLabel = "styles-module--controlLabel--ea8e8";
export var description = "styles-module--description--27dca";
export var disabled = "styles-module--disabled--06323";
export var label = "styles-module--label--67ba4";
export var large = "styles-module--large--cf781";
export var medium = "styles-module--medium--cf3e9";
export var top = "styles-module--top--b7356";